import { AD_OPT_OUT_COOKIE, X_CLICK_ID_COOKIE, X_SCRIPT_COOKIES, isPrivatePagePath } from "@townsy/contracts";
import { readJson, writeJson } from "./storage";

/** ADR-0058: the path this tab last reloaded to drop X's script, so a stray `twq` can never cause a reload loop. */
const RELOAD_MARK = "townsy.xPixelReload.v1";
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;

/**
 * X's script cannot be removed from a running page, and moving between pages does not reload it. So arriving on a
 * private page with the script loaded needs one full reload; the API then sends an empty script.
 */
export function mustReloadToDropXScript(pathname: string, scriptLoaded: boolean, lastReloadedPath: string | null): boolean {
  return scriptLoaded && isPrivatePagePath(pathname) && lastReloadedPath !== pathname;
}

export function dropXScriptOnPrivatePage(pathname: string): void {
  if (!mustReloadToDropXScript(pathname, "twq" in window, readJson<string>("session", RELOAD_MARK))) return;
  writeJson("session", RELOAD_MARK, pathname);
  window.location.reload();
}

export function isAdOptedOut(cookieHeader: string): boolean {
  return cookieHeader.split(/;\s*/).includes(`${AD_OPT_OUT_COOKIE}=1`);
}

/** The cookies to write for a choice: the opt-out itself, and (opting out) clearing what ad measurement stored. */
export function adChoiceCookies(optOut: boolean, hostname: string, secure: boolean): string[] {
  const attributes = `Path=/; SameSite=Lax${secure ? "; Secure" : ""}`;
  if (!optOut) return [`${AD_OPT_OUT_COOKIE}=; Max-Age=0; ${attributes}`];
  const stored = [X_CLICK_ID_COOKIE, ...X_SCRIPT_COOKIES];
  return [
    `${AD_OPT_OUT_COOKIE}=1; Max-Age=${ONE_YEAR_SECONDS}; ${attributes}`,
    ...stored.map((name) => `${name}=; Max-Age=0; ${attributes}`),
    ...stored.map((name) => `${name}=; Max-Age=0; Domain=${hostname}; ${attributes}`),
  ];
}

/** Saves the choice for this browser and reloads, so X's script leaves the page at once. */
export function chooseAdMeasurement(optOut: boolean): void {
  for (const cookie of adChoiceCookies(optOut, window.location.hostname, window.location.protocol === "https:")) document.cookie = cookie;
  window.location.reload();
}
